import { render, staticRenderFns } from "./pdf-view.vue?vue&type=template&id=c5e476ba&scoped=true&"
import script from "./pdf-view.ts?vue&type=script&lang=ts&"
export * from "./pdf-view.ts?vue&type=script&lang=ts&"
import style0 from "./pdf-view.scss?vue&type=style&index=0&id=c5e476ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e476ba",
  null
  
)

export default component.exports